export default "__VITE_ASSET__D7OR2h8z__"